module.exports = __webpack_public_path__ + "img/full0-min.9be02788.png";